export default "__VITE_ASSET__BjYiHSfx__"